/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WebsitesService } from '@app/settings/websites/websites.service';
import { HotelsService } from '@app/hotels/hotels/hotels.service';
import { ApiQuery } from '@app/core/http/api-query';
import { Hotel } from '@app/hotels/hotels/hotel.model';
import { Logger } from '@app/core';

const log = new Logger('HotelsSeoFormComponent');

@Component({
  selector: 'app-hotels-seo-form',
  templateUrl: './hotels-seo-form.component.html',
  styleUrls: ['./hotels-seo-form.component.scss'],
})
export class HotelsSeoFormComponent implements OnInit {
  @Input() hotelSeo: EventGroup = null;
  form: FormGroup;
  companyWebsiteLocales: Array<any>;
  currentWebsiteLocaleId: number;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private websitesService: WebsitesService,
    private hotelsService: HotelsService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getData();
  }

  save() {
    this.hotelsService
      .updateTranslations(this.hotelSeo, { translations: this.form.get('websiteLocales').value })
      .subscribe((res: any) => {
        this.modal.close(res);
      });
  }

  selectCompanyWebSiteLocale(id: number): void {
    this.currentWebsiteLocaleId = id;
  }

  getWebsiteLocaleName(id: number): string {
    const localeObj = this.companyWebsiteLocales.find((x) => x.id === id);
    return localeObj.website.name + ' ' + localeObj.website.url + ' ' + localeObj.locale.locale;
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      websiteLocales: new FormArray([]),
    });
  }

  private getData() {
    log.debug('getData()');
    this.websitesService.getLocales().subscribe((websiteLocales: []) => {
      this.companyWebsiteLocales = websiteLocales;
      const formArray: FormArray = new FormArray([]);
      websiteLocales.forEach((websiteLocale: any) => {
        formArray.push(
          new FormGroup({
            company_website_locale_id: new FormControl(websiteLocale.id),
            description: new FormControl(null),
            slug: new FormControl(null),
            meta_title: new FormControl(null),
            meta_description: new FormControl(null),
            active: new FormControl(false),
            top: new FormControl(false),
          })
        );
      });
      this.form.setControl('websiteLocales', formArray);

      // Взема информацията от API-то и patch-ва контролите един по един
      const query = new ApiQuery().addIncludes('translations');
      this.hotelsService.show(this.hotelSeo.id, query).subscribe((hotel: Hotel) => {
        hotel.translations.forEach((translation: any) => {
          this.form.get('websiteLocales')['controls'].forEach((websiteLocaleControl: FormControl) => {
            if (
              translation.company_website_locale_id ===
              Number(websiteLocaleControl.get('company_website_locale_id').value)
            ) {
              websiteLocaleControl.patchValue(translation);
            }
          });
        });
      });
    });
  }
}
